module.exports = __webpack_public_path__ + "static/img/table_tennis.194efdf.jpg";